export const getState = (store) => store;
export const getThemeState = (store) => store.theme;
export const getUserState = (store) => store.user;
export const getNotificationState = (store) => store.notification;
